import { Typography } from "@material-ui/core";

const ProminentPassengerCount = (props: PropType) => {
  return (
    // div style are same as MailIcon
    <div
      style={{
        position: "fixed",
        top: "2%",
        right: "85%",
        zIndex: 1202,
        color: "white",
      }}
    >
      <Typography variant="h6">
        Passenger Count: {props.passengerCount}
      </Typography>
    </div>
  );
};

interface PropType {
  passengerCount: string;
}

export default ProminentPassengerCount;
